import call from './call';
import {push} from 'connected-react-router';
import {SHOW_MSG} from "../types";
import languages from "../language/languages";
import {MAIN_ROUTE} from "../components/Main/routes";
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";

export default (form) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            let zip=result[1].certInfo.zip;
            if(zip)
                handleBase64ZipResponse(zip, "certs.zip");
            dispatch(push(MAIN_ROUTE));
            dispatch({type: SHOW_MSG, payload: {message: languages[getState().auth.language].processOk,type:'success'}});
        }
    }
    dispatch(call("CertificateService/generateCertificateFromPKCS10",form,onResult));
};